import {changeLog} from './changelog'
import {FlashRepoMigrationRunner} from '@peachy/flash-repo-pure'
import {PeachyFlashRepo} from '../types'
import {Logger} from '@peachy/utility-kit-pure'

export class PeachyFlashRepoMigrationRunner {

    private migrationRunner
    constructor(peachRepo: PeachyFlashRepo, logger: Logger) {
        this.migrationRunner = new FlashRepoMigrationRunner(peachRepo, changeLog, logger)
    }

    public async run() {
        return this.migrationRunner.run()
    }
}
